import { ApartmentLikeTypes as n, isPolygonClosed as a } from "@project-rouge/rg-core";
import { getLocalCorners as i } from "../../geometry-utils/core/index10.js";
import { Vector3toV3 as f } from "../../geometry-utils/index10.js";
import { applyTransform as m } from "../../geometry-utils/core/index2.js";
import { getBoundaries as c } from "./index3.js";
function C(l, s) {
  const r = [];
  for (const t of l)
    if (n.includes(t.type)) {
      for (const p of t.children)
        if (s && s.includes(p.type)) {
          let e = i(p);
          e = e.map((o) => f(m(o, t))), r.push(e.map((o) => [o[0], 0, o[2]]));
        }
    } else {
      let p;
      const e = t.data;
      e && e.polygon ? (p = e.polygon.slice().map((o) => [o[0] + t.pos[0], o[1] + t.pos[1], o[2] + t.pos[2]]), a(p) && p.pop()) : p = i(t), r.push(p.map((o) => [o[0], 0, o[2]]));
    }
  return c(r, 0.03, 0, !0)[0];
}
export {
  C as getBoundaryOfObjects
};
//# sourceMappingURL=index4.js.map
